import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface AutoCompleteSelectProps {
  options: any[];
  label: string;
  size?: number;
  disabled?: boolean;
  selectedValue: any;
  freeSolo?: boolean;
  onChange: (value: any) => void;
  onInputChange?: (value: any) => void;
  optionsValueKey: string;
  optionsLabelKey: string;
  optionOtherLabelKey?: any;
  required?: boolean;
  className?: string; // Add className prop
  clearIcon?: boolean;
}

export const AutoCompleteSelect = ({
  options,
  label,
  size,
  freeSolo,
  selectedValue,
  onChange,
  onInputChange,
  disabled,
  optionsValueKey,
  optionsLabelKey,
  optionOtherLabelKey,
  required,
  className, // Destructure className
  clearIcon = true,
}: AutoCompleteSelectProps) => {
  const [hasText, setHasText] = useState(false);

  useEffect(() => {
    setHasText(!!selectedValue);
  }, [selectedValue]);

  const handleChange = (_e: any, value: any) => {
    onChange(value);
    setHasText(!!value);
  };

  const handleInputChange = (value: any) => {
    if (onInputChange) {
      onInputChange(value);
    }
  }

  return (
    <Autocomplete
      freeSolo={freeSolo}
      size="small"
      options={options}
      value={selectedValue}
      disabled={disabled}
      onChange={handleChange}
      onInputChange={(event, newInputValue) => {
        handleInputChange(newInputValue);
      }}
      clearIcon={clearIcon ? undefined : null}
      // ✅ Show only `name` in the input after selection
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? option
          : option?.[optionsLabelKey] || ''
      }
      renderOption={(props, option) => (
        <li {...props}>
          {optionOtherLabelKey
            ? `${option?.[optionsLabelKey]} (${option?.[optionOtherLabelKey]})`
            : option?.[optionsLabelKey]}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          rows={size ? size : 4}
          className={`${className} ${required ? 'itsarequiredField' : ''} ${hasText ? 'has-text' : ''}`} // Apply classes conditionally
          aria-required={required}
        />
      )}
      isOptionEqualToValue={(option, value) => value && option[optionsValueKey] === value[optionsValueKey]}
    />
  );
};
